import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { RequestResetPasswordModel } from '../../models/account.model';
import { AccountService } from '../../services/account.service';
import { DynamicFormControl, DynamicForm } from '../../models/dynamic.model';

import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';


@Component({
  selector: 'app-request-reset-password',
  templateUrl: './request-reset-password.component.html'
})
export class RequestResetPasswordComponent {
  form: DynamicForm = new DynamicForm();
  success = false;
  error = false;

  constructor(
    private accountService: AccountService,
    protected messageService: MessageService,
    private router: Router) {

  }


  ngOnInit() {


    this.form.title = 'Reset password';
    this.form.key = 'resetForm';
    this.form.submitLabel = 'Reset Password';
    this.form.buttons.push({ label: 'Cancel', key: 'cancel' });

    this.form.addRow();
    this.form.addControl('username', 'text', 'User Name', null, true, null, 12);

  }

  resetPassword(form: any) {
    let model = new RequestResetPasswordModel();
    model.Username = form.value.username;


    this.accountService.requestResetPassword(model)
      .subscribe(response => {
        if (response instanceof HttpErrorResponse) {
          this.error = true;
        }
        else if (response.isError) {
          this.error = true;
        } else {
          this.success = true;
        }
      });
  }

  clickButton(key: string) {
    if (key === 'cancel') {
      this.router.navigate(['/login']);
    }
  }
}
